import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export default class RewindSnapshot extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "year", Model.attribute('year'));
    _defineProperty(this, "snapshotData", Model.attribute('data'));
    _defineProperty(this, "generatedAt", Model.attribute('generatedAt', Model.transformDate));
    _defineProperty(this, "isPublic", Model.attribute('isPublic'));
    _defineProperty(this, "canEdit", Model.attribute('canEdit'));
    _defineProperty(this, "canModerate", Model.attribute('canModerate'));
    _defineProperty(this, "isEmpty", Model.attribute('isEmpty'));
    _defineProperty(this, "user", Model.hasOne('user'));
  }
}
flarum.reg.add('huseyinfiliz-rewind', 'common/models/RewindSnapshot', RewindSnapshot);